<div
  class="bg-abb-background flex flex-col flex-1 min-h-0 rounded-lg p-4 transition-all gap-6 min-w-[38vw]"
  style="max-height: 85vh;"
  [ngClass]="{
    'opacity-0 scale-95 translate-y-10': !open(),
    'translate-y-0 opacity-100 scale-100': open()
  }"
>
  <div class="flex flex-col">
    <div class="flex justify-between items-center gap-x-4">
      @if (title()){
      <h2 class="font-semibold text-xl text-abb-font">{{ title() }}</h2>
      } @else {
      <ng-content select="[header]"></ng-content>
      }
      @if (closable()) {
        <abb-button variant="none" class="flex-1 justify-end text-abb-font/85" (onclick)="handleClose()" [icon]="'abb/close'"/>
      }
    </div>
    @if (subtitle()){
      <h3 class="font-normal text-base text-abb-font">{{ subtitle() }}</h3>
    }
  </div>
  <div class="flex-1 overflow-auto w-full text-abb-font">
    <ng-content></ng-content>
  </div>
  <ng-content select="[footer]"></ng-content>
</div>
